import { cn } from "@/lib/utils";

interface CheckinProgressBarProps {
  completed: number;
  total: number;
}

export const CheckinProgressBar = ({ completed, total }: CheckinProgressBarProps) => {
  const percentage = Math.round((completed / total) * 100);
  
  return (
    <div className="space-y-1.5 w-full mt-4">
      <div className="flex items-center justify-between text-xs text-muted-foreground font-medium">
        <span>{completed} de {total} secciones completadas</span>
        <span>{percentage}%</span>
      </div>
      <div className="h-1.5 w-full bg-secondary rounded-full overflow-hidden">
        <div 
          className="h-full bg-primary transition-all duration-500 ease-out rounded-full" 
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};
